import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, FormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { BasicRegister } from 'src/app/models/basic-register.model';

@Component({
  selector: 'app-add-business',
  templateUrl: './add-business.component.html',
  styleUrls: ['./add-business.component.scss']
})
export class AddBusinessComponent implements OnInit {


  isLinear = false;
  firstFormGroup: UntypedFormGroup;
  secondFormGroup: UntypedFormGroup;
  thirdFormGroup: UntypedFormGroup;

  formAddBusiness: UntypedFormGroup;

  constructor(private formBuilder: UntypedFormBuilder) {}

  ngOnInit(): void {
    this.firstFormGroup = this.formBuilder.group({
      firstCtrl: ['', Validators.required]
    });
    this.secondFormGroup = this.formBuilder.group({
      secondCtrl: ['', Validators.required]
    });
    this.thirdFormGroup = this.formBuilder.group({
      thirdCtrl: ['', Validators.required]
    });

  this.formAddBusiness = this.formBuilder.group({
    cnpj: [null],
    name: [null],
    fantasy_name: [null],
    ie: [null],
    im: [null],
    email: [null],
    comercial_email: [null],
    cep: [null],
    address: [null],
    number: [null],
    district: [null],
    uf_code: [null],
    city_code: [null],
    phone: [null],
    cellphone: [null],
    adress_complement: [null],
    reference_point: [null]
  });

}

    onSubmit(){
    // console.log(this.formAddBusiness.value)
    }

}
